import "@common/css/styles.css";
import { VueQueryPlugin } from "@tanstack/vue-query";
import "primeicons/primeicons.css";
import PrimeVue from "primevue/config";
import StyleClass from "primevue/styleclass";
import Tooltip from "primevue/tooltip";
import 'temporal-polyfill/global';
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./locales";

const app = createApp(App);
app.use(router);
app.use(VueQueryPlugin);
app.use(i18n);
app.use(PrimeVue, {
	unstyled: true,
});
app.directive("styleclass", StyleClass);
app.directive("tooltip", Tooltip);
app.mount("#app");
